module.exports = "/static/assets/d1893578e9f1038e5b70b19465f7b58b.png";